import React, {Component} from 'react'
import PropTypes from 'prop-types'

import ProjectClientList from "./ProjectClientList";
import ProjectClientInput from "./ProjectClientInput";

export default class ProjectClients extends Component{

    render(){

        const {
            clients,
            onRemove,
            project_id
        } = this.props

        return (
            <div>
                <ProjectClientInput project_id={project_id}/>
                <ProjectClientList project_id={project_id} clients={clients}/>
            </div>

        )
    }

}

ProjectClients.propTypes = {
    project_id: PropTypes.string.isRequired,
    clients: PropTypes.array,
}